import { useParams } from "react-router";

import { OwnerFilter } from "./filters/OwnerFilter";
import { ProductFamilyNameFilter } from "./filters/ProductFamilyNameFilter";
import { RelationshipTypeFilter } from "./filters/RelationshipTypeFilter";
import { ResourceTypeFilter } from "./filters/ResourceTypeFilter";
import { SearchResources } from "./search/SearchResources";

export const SectionWithFiltersAndSearch = () => {
  const { organizationId } = useParams();

  return (
    <div className="mt-2 mb-5 flex items-center gap-3">
      <div className="flex grow items-center gap-[15px]">
        <ResourceTypeFilter />
        <ProductFamilyNameFilter />
        {organizationId ? <RelationshipTypeFilter /> : <OwnerFilter />}
      </div>
      <SearchResources />
    </div>
  );
};
